import { render } from "./MasterDataManage.vue?vue&type=template&id=1279f105"
import script from "./MasterDataManage.vue?vue&type=script&lang=js"
export * from "./MasterDataManage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__